import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AppLanguage = 'en' | 'ar';

interface LanguageState {
  lang: AppLanguage;
}

const initialState: LanguageState = {
  lang: 'en',
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    switchLanguage: (state, action: PayloadAction<AppLanguage>) => {
      state.lang = action.payload;
    },
  },
});

export const { switchLanguage } = languageSlice.actions;
export default languageSlice;
